import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Field, Formik, Form, ErrorMessage } from "formik";
import { useEffect, useState, useRef } from "react";
import Alert from "@mui/material/Alert";
import { resetPassword, signIn } from "../../api/authService";
import { Icons } from "../../Components/Icons/Icons";
import SignImage from "../../Assets/Images/sign-in.webp";

const ResetCodeSchema = Yup.object().shape({
  code: Yup.string()
    .length(6, "Code must be exactly 6 digits")
    .required("Code is required"),
});

interface ResetCodeData {
  code: string;
}

export const ResetCode = () => {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleSubmit = async (values: ResetCodeData) => {
    const fullCode = inputRefs.current.map(input => input?.value).join('');
    if (fullCode.length === 6) {
      sessionStorage.setItem("restorePasswordCode", fullCode);
      navigate("/new-password");
    } else {
      setError("Code must be exactly 6 digits");
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, setFieldValue: (field: string, value: any) => void) => {
    const { value } = e.target;
    if (value.length === 1 && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
    const fullCode = inputRefs.current.map(input => input?.value).join('');
    setFieldValue('code', fullCode);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>, setFieldValue: (field: string, value: any) => void) => {
    const pasteData = e.clipboardData.getData("text");
    if (pasteData.length === 6) {
      pasteData.split("").forEach((char, index) => {
        if (inputRefs.current[index]) {
          inputRefs.current[index]!.value = char;
        }
      });
      inputRefs.current[5]?.focus();
      setFieldValue('code', pasteData);
    }
    e.preventDefault();
  };

  return (
    <section className="sign">
      <img src={SignImage} alt="" />
      <div className="wrap">
        <div className="logo">
          {Icons.LogoIcon}
        </div>
        <div className="title">Enter the code you have received</div>
        {error && (
          <Alert className="error" variant="outlined" severity="error">
            {error}
          </Alert>
        )}
        <Formik
          initialValues={{ code: "" }}
          validationSchema={ResetCodeSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form>
              <label className="code-inputs">
                {[0, 1, 2, 3, 4, 5].map((index) => (
                  <Field
                    key={index}
                    innerRef={(el: HTMLInputElement) => (inputRefs.current[index] = el)}
                    type="text"
                    name={`code${index}`}
                    maxLength={1}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e, index, setFieldValue)}
                    onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e, setFieldValue)}
                    className="code-input"
                  />
                ))}
              </label>
              <ErrorMessage name="code">
                {(msg) => <div className="error-message">{msg}</div>}
              </ErrorMessage>
              <button type="submit" disabled={isSubmitting} className="btn">
                Next
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};
